<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="JobModal"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <DIV
      class="row"
    >
      <ItpFormGroup
        cols-md="3"
        name="status"
        :label="'Status'|pgettext('Job')"
      >
        <ItpFormInput
          name="status"
          size="md"
          v-model="item.status"
          readonly
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        cols-md="3"
        name="job_type"
        :label="'Job type'|pgettext('Job')"
      >
        <ItpFormInput
          name="job_type"
          size="md"
          v-model="item.job_type"
          readonly
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        cols-md="3"
        name="created_at"
        :label="'Created at'|gettext"
      >
        <ItpFormInput
          name="created_at"
          size="md"
          v-model="item.created_at"
          readonly
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        cols-md="3"
        name="created_by"
        :label="'Created by'|gettext"
      >
        <ItpFormInput
          name="created_by"
          size="md"
          :model="b_5074589820235598_model"
          readonly
        >
        </ItpFormInput>
      </ItpFormGroup>
    </DIV>
    <HR>
    </HR>
    <DIV>
      <label>
        {{ 'Job data'|gettext }}
      </label>
      <ItpJSONToTable
        truncateText="200"
        :json="item.job_data"
      >
      </ItpJSONToTable>
    </DIV>
    <HR>
    </HR>
    <DIV>
      <label>
        {{ 'Job result'|gettext }}
      </label>
      <ItpJSONToTable
        truncateText="200"
        :json="item.job_result"
      >
      </ItpJSONToTable>
    </DIV>
  </UcBody>
  <template
    slot="footer"
    v-if="loaded"
  >
    <DIV
      class="modal-footer"
    >
      <ItpButton
        :text="'Restart'|gettext"
        variant="danger"
        :spinning="actions.restart.isRunning"
        class="mr-auto"
        v-if="item.status == 'Errored'"
        @click.prevent.stop="evh_2140198529698299_clickPreventStop($event, {})"
      >
      </ItpButton>
    </DIV>
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobModal extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
    default: null,
  })
  id!: string;

  @Watch('id')
  onId(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("id")
  }

  @Prop({
    type: String,
    default: "xl",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.id !== null ? this.$fn.fetch('read_a_job', { parameters: { id: this.id } }) : null
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_5074589820235598_model!: any;
  dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings', 'b_5074589820235598_model'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "xl",
        }
        ,
        b_5074589820235598_model: "{{ item.created_by }",
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: ([this.item.number, this.$fn.gettext('Job')]),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3460_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3460, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_2140198529698299_setData_3466_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2140198529698299_setData_3466, alias=undefined
    return {
      path: "item",
      value: $event.data.response.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_2140198529698299_request_3464_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2140198529698299_request_3464, alias=restart
    return {
      operation: "update_job",
      data: {
        status: "Not Started",
      }
      ,
      parameters: {
        id: this.item.id,
      }
      ,
    }
  }

  async evh_2140198529698299_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2140198529698299_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3460: actions.CloseModalAction;
    evh_7315092382398562_close_3459: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3462: actions.CloseComponentAction;
    evh_2248226175642056_close_3461: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_2140198529698299_setData_3466: actions.SetDataAction;
    evh_2140198529698299_success_3465: actions.EventHandlerImpl;
    act_2140198529698299_request_3464: actions.RequestAction;
    evh_2140198529698299_clickPreventStop_3463: actions.EventHandlerImpl;
    evh_2140198529698299_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3460 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3460_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3459 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3460,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3459],
      }
    );
    const act_2248226175642056_closeComponent_3462 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3461 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3462,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3461],
      }
    );
    const act_2140198529698299_setData_3466 = new actions.SetDataAction(
      {
        actionArgs: this.act_2140198529698299_setData_3466_getActionArgs,
        events: [],
      }
    );
    const evh_2140198529698299_success_3465 = new actions.EventHandlerImpl(
      {
        action: act_2140198529698299_setData_3466,
        event: "success",
        displayName: "setData",
      }
    );
    const act_2140198529698299_request_3464 = new actions.RequestAction(
      {
        actionArgs: this.act_2140198529698299_request_3464_getActionArgs,
        displayName: "restart",
        events: [evh_2140198529698299_success_3465],
      }
    );
    const evh_2140198529698299_clickPreventStop_3463 = new actions.EventHandlerImpl(
      {
        action: act_2140198529698299_request_3464,
        event: "click.prevent.stop",
        displayName: "restart",
      }
    );
    const evh_2140198529698299_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2140198529698299_clickPreventStop_3463],
      }
    );
    return {
      act_7315092382398562_closeModal_3460,
      evh_7315092382398562_close_3459,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3462,
      evh_2248226175642056_close_3461,
      evh_2248226175642056_close,
      act_2140198529698299_setData_3466,
      evh_2140198529698299_success_3465,
      act_2140198529698299_request_3464,
      evh_2140198529698299_clickPreventStop_3463,
      evh_2140198529698299_clickPreventStop,
      restart: act_2140198529698299_request_3464,
    }
  }
}

Vue.component("JobModal", JobModal);

</script>